import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Button,
  Typography,
  OutlinedInput,
  MenuItem,
  withStyles
} from "@material-ui/core";
import Page from "../../common-components/Page";
import { graphViewPeriodFault } from '../../helpers/constants';

import {getFastDataStationId} from "../../helpers/common";
import * as strings from "../../helpers/strings";
import "../../index.css";

import * as userStationsReducers from "../../system/reducer/UserStationsReducers";
import * as downloadRequestReducers from "../../download-request/reducer";
import * as systemDeviceFaultsReducers from "../reducer";
import * as systemDeviceFaultsActionMgr from "../action-mgr";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = {
    rangeSelection: {
        width: "100px"
    },
    dateLabel:{
      width: "42px"
    }, 
    rangeSelectionDate: {
      flexGrow: 0,
      maxWidth: `calc((100% / 12 * 2.5) - 16px)`, 
      flexBasis: `calc((100% / 12 * 2.5) - 16px)`, 
    },
    rangeSelectionDay: {
      marginLeft: "5px",
       width: "70px"
    },
    rangeSelectionMonth: {
        marginLeft: "5px",
        width: "130px"
        // width: 'calc((100% / 5) - 20px)'
    },
    rangeSelectionYear: {
        margin: "0px !important",
        width: "85px"
    },
}

class SystemDeviceFaultsSelect extends Component {
 
  constructor() {
    super();
    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleDeviceChange = this.handleDeviceChange.bind(this);
    this.handleSelectYearStart = this.handleSelectYearStart.bind(this);
    this.handleSelectMonthStart = this.handleSelectMonthStart.bind(this);
    this.handleSelectDayStart = this.handleSelectDayStart.bind(this);
    this.handleSelectYearEnd = this.handleSelectYearEnd.bind(this);
    this.handleSelectMonthEnd = this.handleSelectMonthEnd.bind(this);
    this.handleSelectDayEnd = this.handleSelectDayEnd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this); 

    this.state = {
      selectedStationName: "",
      selectedDeviceName: "All",
      showDialog: false, // State to control the visibility of the dialog

    };
  }
  componentDidMount = () => {
    const { stations, callStationDeviceFaultInfo, setSelectedStationName, callStationDeviceDatesInfo } = this.props;

    if (stations.length > 0) {
      const selectedStation = stations.find(
        (station) => station.id === getFastDataStationId()
      );
      const stationName = selectedStation
        ? selectedStation.name
        : stations[stations.length - 1].name;
      setSelectedStationName(stationName);
      callStationDeviceFaultInfo(stationName);

      const requestData = {
        stationName: stationName,
      };
      callStationDeviceDatesInfo(requestData);
    }
  };

  componentWillUnmount() {
    const {
      selectDeviceName,
      selectDayStart,
      selectYearStart,
      selectMonthStart,
      selectDayEnd,
      selectYearEnd,
      selectMonthEnd
    } = this.props;

    // Reset the state when the component unmounts
    selectDeviceName("All");
    selectDayStart("");
    selectYearStart("");
    selectMonthStart("");
    selectDayEnd("");
    selectYearEnd("");
    selectMonthEnd("");
  }

  handleStationChange = (event) => {
    const { setSelectedStationName, callStationDeviceFaultInfo, callStationDeviceDatesInfo, selectDeviceName, selectMonthStart, selectDayStart, selectYearStart, selectMonthEnd, selectDayEnd, selectYearEnd   } = this.props;
    const selectedStationName = event.target.value;
    setSelectedStationName(selectedStationName);
    callStationDeviceFaultInfo(selectedStationName);
    const requestData = {
      stationName: selectedStationName,
    };
    callStationDeviceDatesInfo(requestData);
    this.setState({ selectedDeviceName: "All" });
    selectDayStart("");
    selectMonthStart("");
    selectYearStart("");
    selectDayEnd("");
    selectMonthEnd("");
    selectYearEnd("");
  };

  handleDeviceChange = (event) =>{
    const { setSelectedDeviceName  } = this.props;
    const selectedDeviceName = event.target.value;
    this.setState({ selectedDeviceName }); // Update local state
    setSelectedDeviceName(selectedDeviceName);
  }

  handleSelectRange = (event) => {
    const { selectView, selectMonthStart, selectDayStart, selectYearStart, selectMonthEnd, selectDayEnd, selectYearEnd } = this.props;
    let targetData = event.target.value;

    // Hide download button when there's a change in display mode
    this.setState({
      selectedDisplayMode: targetData,
    });

    switch (targetData) {
      case "day":
        selectView(targetData);
        break;
      case "month":
        selectView(targetData);
        selectDayStart(""); // Reset selectedDay when changing to "Month" view
        break;
      case "year":
        selectView(targetData);
        selectMonthStart(""); // Reset selectedMonth when changing to "Year" view
        selectDayStart("");   // Reset selectedDay when changing to "Year" view
        break;
      case "range":
        selectView(targetData);
        selectDayStart("");
        selectMonthStart("");
        selectYearStart("");
        selectDayEnd("");
        selectMonthEnd("");
        selectYearEnd("");
        break;
      default:
    }
  };

  handleSelectYearStart = (event) => {
    const { selectYearStart, selectedStationName, callStationDeviceDatesInfo } = this.props;
    const year = parseInt(event.target.value, 0);

    // Set the state and use a callback to ensure the state has been updated
    this.setState({ selectedYearStart: year }, () => {
        selectYearStart(year);

        const requestData = {
            stationName: selectedStationName,
            startYear: year
        };
        callStationDeviceDatesInfo(requestData);
    });
  };

  handleSelectMonthStart = (event) => {
      const { selectMonthStart, selectedStationName, selectedYearStart, callStationDeviceDatesInfo } = this.props;
      const monthYear = event.target.value;  // This should be in the format "YYYY-MM"
    
      this.setState({ selectedMonthStart: monthYear }, () => {
        selectMonthStart(this.state.selectedMonthStart);
    
        const [year, month] = monthYear.split('-');
        const requestData = {
          stationName: selectedStationName,
          startYear: selectedYearStart,
          startMonth: parseInt(month, 10)
        };
        callStationDeviceDatesInfo(requestData);
      });
  };

  handleSelectDayStart = (event) => {
    const { selectDayStart } = this.props;
    const day = event.target.value.padStart(2, '0'); // Ensure the day is zero-padded

    this.setState({ selectedDayStart: day }, () => {
        selectDayStart(day);
    });
  };

  handleSelectYearEnd = (event) => {
    const { selectYearEnd, selectedStationName, selectedYearStart, selectedMonthStart, callStationDeviceDatesInfo } = this.props;
    const year = parseInt(event.target.value, 0);
    const month = selectedMonthStart.split('-')[1]; // This will split "2024-02" and take "02"

    // Set the state and use a callback to ensure the state has been updated
    this.setState({ selectedYearEnd: year }, () => {
        selectYearEnd(year);

        const requestData = {
            stationName: selectedStationName,
            startYear: selectedYearStart,
            startMonth: parseInt(month, 10), // Now using just the month part "02"
            endYear: year
        };
        callStationDeviceDatesInfo(requestData);
    });
  };

  handleSelectMonthEnd = (event) => {
    const { selectMonthEnd, selectedStationName, selectedYearStart, selectedYearEnd, callStationDeviceDatesInfo } = this.props;
    const monthYear = event.target.value; // "YYYY-MM"
    const [year, month] = monthYear.split('-');

    this.setState({ selectedMonthEnd: monthYear }, () => {
        selectMonthEnd(monthYear);
        const requestData = {
            stationName: selectedStationName,
            startYear: selectedYearStart,
            startMonth: this.state.selectedMonthStart.split('-')[1],
            endYear: selectedYearEnd,
            endMonth: parseInt(month, 10)
        };
        callStationDeviceDatesInfo(requestData);
        this.validateDateRange(); // Validate after setting state
    });
  };

  handleSelectDayEnd = (event) => {
    const { selectDayEnd } = this.props;
    const day = event.target.value.padStart(2, '0'); // Ensure the day is zero-padded

    this.setState({ selectedDayEnd: day }, () => {
        selectDayEnd(day);
        this.validateDateRange(); // Optionally check right after the date is set
    });
  };
  
  handleSubmit() {
    const { callQueryDeviceFaultData, selectedStationName, selectedDeviceName, selectedView, selectedYearStart, selectedMonthStart, selectedDayStart, selectedYearEnd, selectedMonthEnd, selectedDayEnd  } = this.props; // Destructure actions from props

    if (!this.validateDateRange()) {
      return; // Stop the submission if the date range is invalid
    }
    // Extract year and month from selectedMonthStart and selectedMonthEnd
    const [startYear, startMonth] = selectedMonthStart.split('-');
    const [endYear, endMonth] = selectedMonthEnd.split('-');

    // Zero pad the day for proper date formatting if necessary
    const formattedStartDay = selectedDayStart.toString().padStart(2, '0');
    const formattedEndDay = selectedDayEnd.toString().padStart(2, '0');

    // Construct the start and end date strings
    let queryDateStart = `${startYear}-${startMonth}`;
    let queryDateEnd = `${endYear}-${endMonth}-${formattedEndDay}`;

    // If the view is 'month' and day is not selected, set queryDateStart to the first day of the month
    if (selectedView === 'month' && !selectedDayStart) {
        queryDateStart += '-01';
    } else {
        queryDateStart += `-${formattedStartDay}`;
    }

    // If only the year is selected (but not the month or day), set queryDateStart to the first day of January of the selected year
    if (selectedYearStart && !selectedMonthStart && !selectedDayStart) {
      queryDateStart = `${selectedYearStart}-01-01`;
    }


    // Construct the request object for the API
    const request = {
        stationName: selectedStationName,
        choiceDate: selectedView, 
        deviceName: selectedDeviceName.toLowerCase(), 
        queryDate: queryDateStart
    };

    // Include queryDateEnd in request if it's defined
    if (queryDateEnd && queryDateEnd !== "-undefined-00" && queryDateEnd !== "-undefined") {
      request["queryDateEnd"] = queryDateEnd;
    }
    // console.log("Handle Submit Request" , request);
    callQueryDeviceFaultData(request);
  }

  handleOpenDialog = () => {
    this.setState({ showDialog: true });
  };
  
  handleCloseDialog = () => {
    this.setState({ showDialog: false });
  };

  validateDateRange = () => {
    const { selectedYearStart, selectedMonthStart, selectedDayStart,
            selectedYearEnd, selectedMonthEnd, selectedDayEnd } = this.props;
  
    // Ensure we have all values to form a complete date
    if (selectedYearStart && selectedMonthStart && selectedDayStart &&
        selectedYearEnd && selectedMonthEnd && selectedDayEnd) {
      const startDate = new Date(selectedYearStart, parseInt(selectedMonthStart.split('-')[1], 10) - 1, selectedDayStart);
      const endDate = new Date(selectedYearEnd, parseInt(selectedMonthEnd.split('-')[1], 10) - 1, selectedDayEnd);
  
      if (startDate > endDate) {
        this.handleOpenDialog(); // Open the dialog if the date range is invalid
        return false;
      }
    }
    return true;
  };

  
  isSubmitDisabled = () => {
    const { selectedView, selectedYearStart, selectedMonthStart, selectedDayStart } = this.props;
    if (selectedView === 'day') {
      // Disable button if year and month are selected but day is not
      return !selectedYearStart || !selectedMonthStart || !selectedDayStart;
    } else if (selectedView === 'month') {
      // Disable button if year is selected but month is not
      return !selectedYearStart || !selectedMonthStart;
    } else if (selectedView === 'year') {
      // Disable button if year is not selected
      return !selectedYearStart;
    } else if (selectedView === 'range') {
      // For range, ensure all start and end dates are selected
      const { selectedYearEnd, selectedMonthEnd, selectedDayEnd } = this.props;
      return !selectedYearStart || !selectedMonthStart || !selectedDayStart ||
             !selectedYearEnd || !selectedMonthEnd || !selectedDayEnd;
    }
    return true; // Default case, disable the button
  };

  render() {
    const {
      classes,
      stations,
      stationDeviceListInfo,
      stationDatesInfo,
      selectedStationName,
      selectedDeviceName,

      selectedView,
      selectedDayStart,
      selectedMonthStart,
      selectedYearStart,
      selectedDayEnd,
      selectedMonthEnd,
      selectedYearEnd,
    } = this.props;

    // Function to get the list of years from the start year to the current year
    const getYearList = (startYearList) => {
      const currentYear = new Date().getFullYear();
      const startYear = startYearList.length > 0 ? parseInt(startYearList[0], 10) : currentYear;
      const years = [];

      for (let year = startYear; year <= currentYear; year++) {
        years.push({
          year: year.toString(),
          enabled: startYearList.includes(year.toString())
        });
      }
      // If current year is not in the startYearList, add it manually
      if (!years.some(y => y.year === currentYear.toString())) {
        years.push({
          year: currentYear.toString(),
          enabled: true
        });
      }

      return years;
    };

    // previous code
    // const getYearList = (startYearList) => {
    //   const currentYear = new Date().getFullYear();
    //   const startYear = parseInt(startYearList[0], 10);
    //   const years = [];

    //   for (let year = startYear; year <= currentYear; year++) {
    //     years.push({
    //       year: year.toString(),
    //       enabled: startYearList.includes(year.toString())
    //     });
    //   }

    //   return years;
    // };

    // Function to get the list of all months
    const getAllMonths = (year) => {
      const months = [];
      for (let i = 1; i <= 12; i++) {
        const month = i.toString().padStart(2, '0');
        months.push(`${year}-${month}`);
      }
      return months;
    };

  // Function to get the list of all days for a given month
  const getAllDays = (yearMonth) => {
    const [year, month] = yearMonth.split('-');
    const date = new Date(year, month, 0);
    const days = [];
    for (let i = 1; i <= date.getDate(); i++) {
      days.push(i.toString().padStart(2, '0'));
    }
    return days;
  };

    // Function to convert "YYYY-MM" format to month name
    const getMonthName = (yearMonth) => {
      const [year, month] = yearMonth.split('-');
      const date = new Date(`${year}-${month}-01`);
      const monthName = date.toLocaleString('default', { month: 'long' });
      return `${monthName}`;
    };

    const sortStations = stations.sort((a, b) => (a.name > b.name ? 1 : -1));
    const isButtonDisabled = this.isSubmitDisabled();
    const { showDialog } = this.state; 
  
    let description = "";
    const selectedStation = stations.filter(station => station.name === selectedStationName)[0];
    if (selectedStation) {
      description = selectedStation.description;
    }

    return (
      <Paper>
        <Page title={strings.lblSystemFault}>
          <Grid container spacing={16}>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectStation}>
                  {strings.lblStation}
                </InputLabel>
                <Select
                  value={selectedStationName}
                  onChange={this.handleStationChange}
                  input={
                    <OutlinedInput
                      labelWidth={60}
                      name={strings.lblStations}
                      id={strings.idSelectStation}
                    />
                  }
                >
                  {sortStations.map((station) => (
                    <MenuItem key={station.id} value={station.name}>
                      {station.name} - {station.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectDevice}>
                  {strings.lblDevice}
                </InputLabel>
                  <Select
                    value={this.state.selectedDeviceName} // Use state value here
                    onChange={this.handleDeviceChange}
                    input={
                        <OutlinedInput
                            labelWidth={60}
                            name={strings.lblDevice}
                            id={strings.idSelectDevice}
                        />
                    }
                    >
                    <MenuItem value="All">All</MenuItem>
                    {stationDeviceListInfo.data && stationDeviceListInfo.data.deviceList ? (
                        stationDeviceListInfo.data.deviceList.map((deviceName) => (
                            deviceName === "No data available" ? (
                                <MenuItem key={deviceName} value={deviceName} disabled>
                                    {deviceName}
                                </MenuItem>
                            ) : (
                                <MenuItem key={deviceName} value={deviceName}>
                                    {deviceName}
                                </MenuItem>
                            )
                        ))
                    ) : (
                        <MenuItem disabled>No data available</MenuItem>
                    )}
                  </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} sm={6} xs={12} >
              <FormControl variant={strings.txtOutlined} fullWidth={true} >
                <InputLabel htmlFor={strings.idSelectYear} className={classes.rangeSelection}>
                  {strings.lblDisplayMode}
                </InputLabel>
                <Select
                  value={selectedView}
                  onChange={this.handleSelectRange}
                  input={
                    <OutlinedInput
                      labelWidth={100}
                      name={strings.lblRange}
                      id={strings.idSelectRange}
                    />
                  }
                >
                  <MenuItem
                    key={graphViewPeriodFault.yearEnd}
                    value={graphViewPeriodFault.yearEnd}
                  >
                    {strings.lblYear}
                  </MenuItem>
                  <MenuItem
                    key={graphViewPeriodFault.monthEnd}
                    value={graphViewPeriodFault.monthEnd}
                  >
                    {strings.lblMonth}
                  </MenuItem>
                  <MenuItem
                    key={graphViewPeriodFault.dayStart}
                    value={graphViewPeriodFault.dayStart}
                  >
                    {strings.lblDay}
                  </MenuItem>
                  <MenuItem
                    key={graphViewPeriodFault.range}
                    value={graphViewPeriodFault.range}
                  >
                    {strings.lblRange}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>           
            <Grid item md={2} sm={6} xs={12} className={classes.rangeSelectionDate}>
            {selectedView === graphViewPeriodFault.range && (
                  <FormControl variant="standard" className={classes.dateLabel}>{strings.lblStartDate}</FormControl> 
            )}
            {(
                selectedView === graphViewPeriodFault.dayStart ||
                selectedView === graphViewPeriodFault.monthStart ||
                selectedView === graphViewPeriodFault.yearStart ||
                selectedView === graphViewPeriodFault.range
              ) && (
                  <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionYear}>
                    <InputLabel htmlFor={strings.idSelectYear}>
                      {strings.lblYear}
                    </InputLabel>
                    <Select
                      value={selectedYearStart}
                      onChange={this.handleSelectYearStart}
                      input={
                        <OutlinedInput
                          labelWidth={60}
                          name={strings.lblYear}
                          id={strings.idSelectYear}
                        />
                      }
                    >
                      {stationDatesInfo.data ? (
                        getYearList(stationDatesInfo.data.startYearList).map(({ year}) => (
                          <MenuItem key={year} value={year}>{year}</MenuItem>
                        ))
                      ) : (
                        // Always show current year if no data available
                        <MenuItem key={new Date().getFullYear()} value={new Date().getFullYear()}>{new Date().getFullYear()}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
            )}
            
              {(selectedView === graphViewPeriodFault.dayStart ||
                selectedView === graphViewPeriodFault.monthStart || 
                selectedView === graphViewPeriodFault.range) && (
                  <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionMonth}>
                    <InputLabel htmlFor={strings.idSelectMonth}>
                      {strings.lblMonth}
                    </InputLabel>
                    <Select
                      value={selectedMonthStart}
                      onChange={this.handleSelectMonthStart}
                      input={
                        <OutlinedInput
                          labelWidth={60}
                          name={strings.lblMonth}
                          id={strings.idSelectMonth}
                        />
                      }
                    >
                      {stationDatesInfo.data && selectedYearStart && (
                        getAllMonths(selectedYearStart).map(monthYear => (
                          <MenuItem key={monthYear} value={monthYear} disabled={!(stationDatesInfo.data.startMonthList && stationDatesInfo.data.startMonthList.includes(monthYear))}>
                            {getMonthName(monthYear)}
                          </MenuItem>
                        ))
                      ) || (
                        <MenuItem value="" disabled>Unavailable</MenuItem>
                      )}
                    </Select>
                  </FormControl>
              )}
              {(selectedView === graphViewPeriodFault.dayStart ||
               selectedView === graphViewPeriodFault.range) && (
                <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionDay}>
                    <InputLabel htmlFor={strings.idSelectDay}>
                      {strings.lblDay}
                    </InputLabel>
                    <Select
                      value={selectedDayStart}
                      onChange={this.handleSelectDayStart}
                      input={
                        <OutlinedInput
                          labelWidth={60}
                          name={strings.lblDay}
                          id={strings.idSelectDay}
                        />
                      }
                    >
                    {stationDatesInfo.data && selectedMonthStart ? (
                        getAllDays(selectedMonthStart).map((day) => {
                            const fullDate = `${selectedMonthStart}-${day}`;
                            return (
                                <MenuItem key={fullDate} value={day} disabled={!(stationDatesInfo.data.startDayList && stationDatesInfo.data.startDayList.includes(fullDate))}>
                                    {day}
                                </MenuItem>
                            );
                        })
                    ) : (
                        <MenuItem value="" disabled>Unavailable</MenuItem>
                    )}
                    </Select>
                  </FormControl>
              )}
            </Grid>
            <Grid item md={2} sm={6} xs={12} className={classes.rangeSelectionDate}>
            {selectedView === graphViewPeriodFault.range && (
              <FormControl variant="standard" className={classes.dateLabel}> {strings.lblEndDate}</FormControl> 
            )}
              {(
                selectedView === graphViewPeriodFault.range
              ) && (
                <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionYear}>
                    <InputLabel htmlFor={strings.idSelectYear}>
                    {strings.lblYear}
                    </InputLabel>
                    <Select
                        value={selectedYearEnd}
                        onChange={this.handleSelectYearEnd}
                    input={
                        <OutlinedInput
                        labelWidth={60}
                        name={strings.lblYear}
                        id={strings.idSelectYear}
                        />
                    }
                    >
                    {stationDatesInfo.data && stationDatesInfo.data.endYearList.length > 0 ? (
                      getYearList(stationDatesInfo.data.endYearList).map(({ year, enabled }) => (
                        <MenuItem key={year} value={year} disabled={!enabled}>{year}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>Unavailable</MenuItem>
                    )}
                    </Select>
                </FormControl>
            )}
            {(
              selectedView === graphViewPeriodFault.range
            ) && (
                <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionMonth}>
                  <InputLabel htmlFor={strings.idSelectMonth}>
                    {strings.lblMonth}
                  </InputLabel>
                  <Select
                    value={selectedMonthEnd}
                    onChange={this.handleSelectMonthEnd}
                    input={
                      <OutlinedInput
                        labelWidth={60}
                        name={strings.lblMonth}
                        id={strings.idSelectMonth}
                      />
                    }
                  >
                    {stationDatesInfo.data && selectedYearEnd && (
                      getAllMonths(selectedYearEnd).map(monthYear => (
                        <MenuItem key={monthYear} value={monthYear} disabled={!(stationDatesInfo.data.endMonthList && stationDatesInfo.data.endMonthList.includes(monthYear))}>
                          {getMonthName(monthYear)}
                        </MenuItem>
                      ))
                    ) || (
                      <MenuItem value="" disabled>Unavailable</MenuItem>
                    )}
                  </Select>
                </FormControl>
            )}
            {selectedView === graphViewPeriodFault.range
                && (
                  <FormControl variant={strings.txtOutlined} className={classes.rangeSelectionDay}>
                  <InputLabel htmlFor={strings.idSelectDay}>
                    {strings.lblDay}
                  </InputLabel>
                  <Select
                    value={selectedDayEnd}
                    onChange={this.handleSelectDayEnd}
                    input={
                      <OutlinedInput
                        labelWidth={60}
                        name={strings.lblDay}
                        id={strings.idSelectDay}
                      />
                    }
                  >
                  {stationDatesInfo.data && selectedMonthEnd ? (
                      getAllDays(selectedMonthEnd).map((day) => {
                          const fullDate = `${selectedMonthEnd}-${day}`;
                          return (
                              <MenuItem key={fullDate} value={day} disabled={!(stationDatesInfo.data.endDayList && stationDatesInfo.data.endDayList.includes(fullDate))}>
                                  {day}
                              </MenuItem>
                          );
                      })
                  ) : (
                      <MenuItem value="" disabled>Unavailable</MenuItem>
                  )}
                  </Select>
                </FormControl>
              )}
            </Grid>
            {/* <Grid item xs={12}>
              <Typography variant="body1">{description}</Typography>
            </Grid> */}
            <Grid item xs={12}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={this.handleSubmit}
                    disabled={isButtonDisabled}
                >
                    Submit
                </Button>
            </Grid>
          </Grid>
          <Dialog
            open={showDialog}
            onClose={this.handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Invalid Date Range"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                The end date must be later than the start date.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseDialog} color="primary" autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </Page>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  stations: userStationsReducers.getStations(state),
  getStnAvaliableTime: downloadRequestReducers.getStnAvaliableTime(state),
  selectedStationName: systemDeviceFaultsReducers.getSelectedStationName(state),
  stationDeviceListInfo: systemDeviceFaultsReducers.getStationDeviceFaultDeviceListInfo(state),
  stationDatesInfo: systemDeviceFaultsReducers.getStationDeviceFaultDatesInfo(state),
  queryDeviceFaultData: systemDeviceFaultsReducers.getQueryDeviceFaultData(state),

  selectedDeviceName: systemDeviceFaultsReducers.getSelectedDeviceName(state),

  selectedView: systemDeviceFaultsReducers.getSelectedView(state),
  selectedDayStart: systemDeviceFaultsReducers.getSelectedDayStart(state),
  selectedMonthStart: systemDeviceFaultsReducers.getSelectedMonthStart(state),
  selectedYearStart: systemDeviceFaultsReducers.getSelectedYearStart(state),
  selectedDayEnd: systemDeviceFaultsReducers.getSelectedDayEnd(state),
  selectedMonthEnd: systemDeviceFaultsReducers.getSelectedMonthEnd(state),
  selectedYearEnd: systemDeviceFaultsReducers.getSelectedYearEnd(state),
});

const mapActionsToProps = {
  setSelectedStationName: systemDeviceFaultsActionMgr.setSelectedStationName,
  callStationDeviceFaultInfo:systemDeviceFaultsActionMgr.fetchStationDeviceFaultDeviceListInfo,
  callStationDeviceDatesInfo:systemDeviceFaultsActionMgr.fetchStationDeviceFaultDatesInfo,
  callQueryDeviceFaultData: systemDeviceFaultsActionMgr.fetchQueryDeviceFaultData,
  setSelectedDeviceName: systemDeviceFaultsActionMgr.setSelectedDeviceName,

  callDeviceFaultSummaryApi: systemDeviceFaultsActionMgr.callDeviceFaultSummaryApi,
  callDeviceFaultDetailsApi:systemDeviceFaultsActionMgr.callDeviceFaultDetailsApi,
  callDeviceFaultCountApi:systemDeviceFaultsActionMgr.callDeviceFaultCountApi,

  selectView: systemDeviceFaultsActionMgr.selectView,
  selectDeviceName: systemDeviceFaultsActionMgr.setSelectedDeviceName,
  selectDayStart: systemDeviceFaultsActionMgr.selectDayStart,
  selectYearStart: systemDeviceFaultsActionMgr.selectYearStart,
  selectMonthStart: systemDeviceFaultsActionMgr.selectMonthStart,
  selectDayEnd: systemDeviceFaultsActionMgr.selectDayEnd,
  selectYearEnd: systemDeviceFaultsActionMgr.selectYearEnd,
  selectMonthEnd: systemDeviceFaultsActionMgr.selectMonthEnd,
};

export default connect(mapStateToProps, mapActionsToProps)(
    withStyles(styles)(SystemDeviceFaultsSelect)
  );